import UseAxios from '../../../Api/http/http';
import { setKpi } from '../../../Api/request/manageKpi';
import { STATUS_CODES } from '../../../Api/resources/statusCodes';
import { AUTHENTICATION_FAILED, OOPS_TRY_AGAIN } from '../../../Constants/strings';

export const addKpi = async (data) => {
  try {
    const response = await UseAxios(setKpi(data));
    if (response.data.status === STATUS_CODES.SUCCESS) {
      return {
        status: STATUS_CODES.SUCCESS,
      };
    } else {
      switch (response.data?.response?.status) {
      case STATUS_CODES.UNAUTHORIZED:
        return {
          failure: AUTHENTICATION_FAILED,
        };
      case STATUS_CODES.BAD_REQUEST:
        if (response.data.response.data.errorCode === 'EXISTING_KPI_DETAILS_ERROR') {
          return {
            failure: response.data.response.data.externalMessage,
          };
        } else {
          return {
            failure: OOPS_TRY_AGAIN,
          };
        }
      case STATUS_CODES.INTERNAL_SERVER_ERROR:
      default:
        return {
          failure: OOPS_TRY_AGAIN,
        };
      }
    }
  } catch (error) {
    return [];
  }
};
